"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var IconBase_1 = require("./IconBase");
var Calendar = function (props) { return (React.createElement(IconBase_1.default, __assign({}, props),
    React.createElement("path", { d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z" }),
    React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }))); };
exports.Calendar = Calendar;
var Clear = function (props) { return (React.createElement(IconBase_1.default, __assign({}, props),
    React.createElement("path", { fill: "none", d: "M0 0h24v24H0V0z" }),
    React.createElement("path", { d: "M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" }))); };
exports.Clear = Clear;
var LeftArrow = function (props) { return (React.createElement(IconBase_1.default, __assign({}, props),
    React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    React.createElement("path", { d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" }))); };
exports.LeftArrow = LeftArrow;
var RightArrow = function (props) { return (React.createElement(IconBase_1.default, __assign({}, props),
    React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    React.createElement("path", { d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" }))); };
exports.RightArrow = RightArrow;
var Time = function (props) { return (React.createElement(IconBase_1.default, __assign({}, props),
    React.createElement("path", { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" }),
    React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    React.createElement("path", { d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" }))); };
exports.Time = Time;
var Up = function (props) { return (React.createElement(IconBase_1.default, __assign({}, props),
    React.createElement("path", { d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" }),
    React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }))); };
exports.Up = Up;
var Down = function (props) { return (React.createElement(IconBase_1.default, __assign({}, props),
    React.createElement("path", { d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" }),
    React.createElement("path", { fill: "none", d: "M0 0h24v24H0V0z" }))); };
exports.Down = Down;
//# sourceMappingURL=Icons.js.map